// Code128 (кодировка B) — единый источник для экранного <Barcode> и печати этикеток.
// Тот же алгоритм, что читается сканером (ScanModal), — печать 1:1 сканируется.
const PATTERNS = [
  '212222',
  '222122',
  '222221',
  '121223',
  '121322',
  '131222',
  '122213',
  '122312',
  '132212',
  '221213',
  '221312',
  '231212',
  '112232',
  '122132',
  '122231',
  '113222',
  '123122',
  '123221',
  '223211',
  '221132',
  '221231',
  '213212',
  '223112',
  '312131',
  '311222',
  '321122',
  '321221',
  '312212',
  '322112',
  '322211',
  '212123',
  '212321',
  '232121',
  '111323',
  '131123',
  '131321',
  '112313',
  '132113',
  '132311',
  '211313',
  '231113',
  '231311',
  '112133',
  '112331',
  '132131',
  '113123',
  '113321',
  '133121',
  '313121',
  '211331',
  '231131',
  '213113',
  '213311',
  '213131',
  '311123',
  '311321',
  '331121',
  '312113',
  '312311',
  '332111',
  '314111',
  '221411',
  '431111',
  '111224',
  '111422',
  '121124',
  '121421',
  '141122',
  '141221',
  '112214',
  '112412',
  '122114',
  '122411',
  '142112',
  '142211',
  '241211',
  '221114',
  '413111',
  '241112',
  '134111',
  '111242',
  '121142',
  '121241',
  '114212',
  '124112',
  '124211',
  '411212',
  '421112',
  '421211',
  '212141',
  '214121',
  '412121',
  '111143',
  '111341',
  '131141',
  '114113',
  '114311',
  '411113',
  '411311',
  '113141',
  '114131',
  '311141',
  '411131',
  '211412',
  '211214',
  '211232',
  '2331112',
];
const START_B = 104;
const STOP = 106;

function encode(value: string): number[] {
  const codes = [START_B];
  for (const ch of value) codes.push(ch.charCodeAt(0) - 32);
  let sum = START_B;
  for (let i = 1; i < codes.length; i++) sum += codes[i] * i;
  codes.push(sum % 103);
  codes.push(STOP);
  return codes;
}

// Чёрные штрихи (модульная ширина) + суммарная ширина в модулях.
export function barcodeBars(value: string): { bars: { x: number; w: number }[]; total: number } {
  const codes = encode(value);
  const bars: { x: number; w: number }[] = [];
  let x = 0;
  for (const code of codes) {
    const pattern = PATTERNS[code];
    for (let i = 0; i < pattern.length; i++) {
      const w = parseInt(pattern[i], 10);
      if (i % 2 === 0) bars.push({ x, w }); // чётные — штрихи (чёрные)
      x += w;
    }
  }
  return { bars, total: x };
}

// Готовая SVG-разметка (строкой) для окна печати. Ширина тянется на контейнер,
// высота задаётся в физических мм; вектор — чёткие штрихи при любом DPI.
export function barcodeSvgMarkup(value: string, cssHeight = '12mm'): string {
  const { bars, total } = barcodeBars(value);
  const rects = bars.map((b) => `<rect x="${b.x}" y="0" width="${b.w}" height="40"/>`).join('');
  return (
    `<svg viewBox="0 0 ${total} 40" preserveAspectRatio="none" width="100%" height="${cssHeight}">` +
    `<rect width="${total}" height="40" fill="#fff"/><g fill="#000">${rects}</g></svg>`
  );
}
